import * as Mutations from "@/store/mutations.type";

export default {
  [Mutations.FETCH_CATEGORY_INFO](state, categoryInfo) {
    state.categoryInfo = categoryInfo;
  },
  [Mutations.FETCH_CATEGORY_SLUG_OPTIONS](state, categoryInfo) {
    state.categorySlugOptions = categoryInfo;
  },
  [Mutations.SET_PREVIEW_URL](state, url) {
    state.previewUrl = url;
  },
  [Mutations.SET_CATEGORY_INSTANCE_PAGE](state, page) {
    state.page = page;
  },
  [Mutations.SET_CATEGORY_SEARCH](state, search) {
    state.search = search;
  },
  [Mutations.SET_CATEGORY_OPTIONS_SEARCH](state, search) {
    state.categorySlugOptionsSearch = search;
  },
  [Mutations.SET_CATEGORY_ERROR](state, error) {
    state.error = error;
  },
  [Mutations.SET_CATEGORY_SUCCESS](state, success) {
    state.success = success;
  },
  [Mutations.SET_EXIST_CATEGORY](state, names) {
    state.existCategories = names;
  },
  [Mutations.SET_CATEGORY_LOADING](state, { type, status }) {
    state.loading[type] = status;
  },
  [Mutations.ADD_CATEGORY_ATTRIBUTES](state, { componentId, attributes }) {
    state.categoryAllAttributes[componentId] = attributes;
  },
  [Mutations.SET_CATEGORY_OPERATION](state, status) {
    state.operation = status;
  },
  [Mutations.SET_CATEGORY_INSTANCE](state, instance) {
    state.categoryInstance = instance;
  },
  [Mutations.CLEAR_CATEGORY_INSTANCE](state) {
    state.categoryInstance = {};
  }
};
